import type { RegioStageBackgroundIconProps } from './interfaces';
import styles from './RegioStageBackgroundIcon.module.scss';
import Icon from '@uikit/components/Icon/Icon';
import clsx from 'clsx';
import { toCamelCase } from '@uikit/utils/convertCase';
import { animated, easings, useSpring } from '@react-spring/web';

const RegioStageBackgroundIcon = ({
  variant,
  size,
}: RegioStageBackgroundIconProps) => {
  const styleVariant = toCamelCase(variant);
  const animationDuration = (1 + Math.random()) * 2000;

  const [animatedStyles] = useSpring(() => ({
    from: { filter: 'blur(0px)', transform: 'translateZ(0px)', opacity: 1 },
    to: {
      filter: 'blur(3px)',
      transform: 'translateZ(-100px)',
      opacity: 0.3,
    },
    loop: {
      reverse: true,
      reset: false,
      config: { easing: easings.easeInOutSine },
    },
    config: {
      duration: animationDuration,
    },
  }));

  return (
    <div className={clsx(styles.base, styles[styleVariant], styles[size])}>
      <animated.div style={{ willChange: 'transform', ...animatedStyles }}>
        <Icon
          className={styles.icon}
          variant={`user/${variant}`}
          size="iconSize128"
          isOutlined
        />
      </animated.div>
    </div>
  );
};

export default RegioStageBackgroundIcon;
